module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/effects-and-pedals-8903eec83059c401fbf17c418cfc0d6b.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/effects-and-pedals.png
// module id = Xtiv
// module chunks = 9 12